<template>
    <v-container fluid class="pa-0">
        <!-- Product Category Dialog -->
        <ProductCategoryEditDialog
            :dialog.sync="productCategoryDialog"
            :object.sync="editedProductCategory"
        ></ProductCategoryEditDialog>

        <!-- Product info -->
        <v-hover>
            <template v-slot="{ hover }">
                <v-card :elevation="hover ? 6 : 1" :loading="loading">
                    <slot name="header"></slot>
                    <div class="pa-3">
                        <v-row align="center" class="mx-0">
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <div class="caption grey--text text--darken-2">
                                    Product Name
                                </div>
                                <div class="subtitle-2">{{ product.name }}</div>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <div class="caption grey--text text--darken-2">
                                    Product Category
                                </div>
                                <div class="subtitle-2">
                                    {{
                                        product.productCategory
                                            ? product.productCategory.name
                                            : ""
                                    }}
                                    <v-btn
                                        icon
                                        small
                                        v-if="
                                            hasPermission(
                                                'change_productcategory'
                                            )
                                        "
                                        @click="
                                            editProductCategory(
                                                product.productCategory
                                            )
                                        "
                                        ><v-icon small color="grey"
                                            >edit</v-icon
                                        ></v-btn
                                    >
                                </div>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12">
                                <div class="caption grey--text text--darken-2">
                                    Dynamic
                                </div>
                                <v-switch
                                    class="mt-0"
                                    hide-details
                                    value
                                    :input-value="product.isDynamic"
                                    disabled
                                ></v-switch>
                            </v-col>
                            <v-col cols="6" sm="6" v-if="product.isDynamic">
                                <div class="caption grey--text text--darken-2">
                                    # Plants
                                </div>
                                <div class="display-1">
                                    {{ product.numMixPlantsPerUnitMin }}-{{
                                        product.numMixPlantsPerUnitMax
                                    }}
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6" v-if="product.isDynamic">
                                <div class="caption grey--text text--darken-2">
                                    # Colors
                                </div>
                                <div
                                    v-if="product.numColorsPerUnitMax"
                                    class="display-1"
                                >
                                    {{ product.numColorsPerUnitMin }}-{{
                                        product.numColorsPerUnitMax
                                    }}
                                </div>
                                <div v-else class="headline grey--text">
                                    No limit
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <div class="caption grey--text text--darken-2">
                                    External Code
                                </div>
                                <div class="subtitle-2">
                                    {{ product.externalCode || "-" }}
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <div class="caption grey--text text--darken-2">
                                    External ID
                                </div>
                                <div class="subtitle-2">
                                    {{ product.externalId || "-" }}
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <div class="caption grey--text text--darken-2">
                                    External PotSize
                                </div>
                                <div class="subtitle-2">
                                    {{ product.externalPotsize || "-" }}
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <div class="caption grey--text text--darken-2">
                                    External Height
                                </div>
                                <div class="subtitle-2">
                                    {{ product.externalHeight || "-" }}
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <div class="caption grey--text text--darken-2">
                                    External Cover
                                </div>
                                <div class="subtitle-2">
                                    {{ product.externalCover || "-" }}
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <div class="caption grey--text text--darken-2">
                                    External Label
                                </div>
                                <div class="subtitle-2">
                                    {{ product.externalLabel || "-" }}
                                </div>
                            </v-col>
                            <v-col cols="6" sm="6">
                                <div class="caption grey--text text--darken-2">
                                    External Sticker
                                </div>
                                <div class="subtitle-2">
                                    {{ product.externalSticker || "-" }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="caption grey--text text--darken-2">
                                    Print Priority
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                >help_outline</v-icon
                                            >
                                        </template>
                                        <span
                                            >If empty, the product inherits
                                            priority from its Product
                                            Category!</span
                                        >
                                    </v-tooltip>
                                </div>
                                <div class="subtitle-2">
                                    {{
                                        product.printPriority != null
                                            ? product.printPriority
                                            : "-"
                                    }}
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <div class="caption grey--text text--darken-2">
                                    Unit Correction
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on"
                                                >help_outline</v-icon
                                            >
                                        </template>
                                        <span
                                            >Used in sales price
                                            calculation!</span
                                        >
                                    </v-tooltip>
                                </div>
                                <div class="subtitle-2">
                                    {{
                                        product.unitCorrection != null
                                            ? product.unitCorrection
                                            : "-"
                                    }}
                                </div>
                            </v-col>
                            <!-- <v-col cols="12">
                            <div class="caption grey--text text--darken-2">Sales Price</div>
                            <div class="subtitle-2">{{ product.salesPrice }}</div>
                        </v-col>
                        <v-col cols="12">
                            <div class="caption grey--text text--darken-2">Currency</div>
                            <div class="subtitle-2">{{ product.currency }}</div>
                        </v-col>-->
                        </v-row>
                    </div>
                    <slot name="footer"></slot>
                </v-card>
            </template>
        </v-hover>
    </v-container>
</template>

<script>
import helper from "@/utils/helper.js";
import ProductCategoryEditDialog from "@/components/products/ProductCategoryEditDialog.vue";

export default {
    name: "product-info-card",
    props: ["product", "loading"],
    components: {
        ProductCategoryEditDialog
    },

    data: function() {
        return {
            productCategoryDialog: false,
            // edited item
            editedProductCategory: {}
        };
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },

    methods: {
        editProductCategory(productCategory) {
            this.editedProductCategory = JSON.parse(
                JSON.stringify(productCategory)
            );

            this.productCategoryDialog = true;
        }
    }
};
</script>